import { render, staticRenderFns } from "./case-item.vue?vue&type=template&id=80804d34&scoped=true&"
import script from "./case-item.vue?vue&type=script&lang=js&"
export * from "./case-item.vue?vue&type=script&lang=js&"
import style0 from "./case-item.vue?vue&type=style&index=0&id=80804d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80804d34",
  null
  
)

export default component.exports